import { ShippingMethodMap, type ShippingMethodType } from '@hooks-api/types/dataModel/shipping'
import { HStack } from '@pets-ui/HStack/HStack'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { Check, Copy } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { copyText, formatPrice } from '@utils'
import { type ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface OrderIdsInfoProps {
  receiverName?: string
  orderId?: string
  displayStatus?: ReactNode
  total?: number
  paymentMethod?: string
  shippingMethodType?: ShippingMethodType
  currency?: string
}

export function OrderIdsInfo({ receiverName, orderId, displayStatus, total: totalProps, paymentMethod, shippingMethodType, currency }: OrderIdsInfoProps) {
  const [isCopied, setIsCopied] = useState(false)
  const { t } = useTranslation()

  const handleCopyText = async () => {
    const total = totalProps ? formatPrice(currency, totalProps) : ''

    const text = `${t('orderDetail.receiverName', { defaultValue: '收件人' })}：${receiverName}
${t('orderDetail.orderId', { defaultValue: '訂單編號' })}：${orderId}
${t('orderDetail.orderTotal', { defaultValue: '訂單金額' })}：${total}
${t('orderDetail.paymentMethod', { defaultValue: '付款方式' })}：${paymentMethod}
${t('orderDetail.shippingRules', { defaultValue: '配送方式' })}：${shippingMethodType ? ShippingMethodMap[shippingMethodType] : ''}`

    await copyText(text)
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false)
    }, 800)
  }

  return (
    <HStack gap={2} alignItems="center">
      <Text variant="body">{`${orderId}（${displayStatus}）`}</Text>
      {isCopied
        ? <Check color={colors.green600} fontSize={20} />
        : (
          <IconButton variant="text" onClick={handleCopyText}>
            <Copy color={colors.grey600} fontSize={24} />
          </IconButton>
        )}
    </HStack>
  )
}
